"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
const React = require('react');
const RaisedButton_1 = require('material-ui/RaisedButton');
const getDefaultProps = () => ({
    disabledTouchRipple: true,
    primary: true,
});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (props) => {
    const _props = Object.assign(getDefaultProps(), props);
    return (React.createElement(RaisedButton_1.default, __assign({}, _props), props.children));
};



/** WEBPACK FOOTER **
 ** ./src/components/RaisedButton.tsx
 **/